import React from 'react'
import { Helmet } from 'react-helmet-async'
import useBreakpoint from '#src/hooks/useBreakpoint'
import Header from '../Header'
import classnames from 'classnames'
import styles from './styles.css'

export interface ChromeProps {
  /**
   * If `true`, the Chrome will act as the scroll container, preventing mobile browser's
   * address bar and other browser toolbars from collapsing. This is useful to prevent
   * issues with "dead zones" on browsers like mobile Safari.
   *
   * See: https://www.eventbrite.com/engineering/mobile-safari-why/
   */
  fixed?: boolean
  contentClassName?: string
  headerClassName?: string
  /**
   * If the sticky header is present, then it will be shown. This defers the rendering
   * of the sticky header to the individual implementations instead of relying on duplicate
   * props.
   */
  stickyHeader?: JSX.Element
  replaceSearchWithPath?: boolean
  hideSecondaryNav?: boolean
  hideHeader?: boolean
}

const Chrome: React.SFC<ChromeProps> = ({
  fixed,
  contentClassName,
  headerClassName,
  children,
  stickyHeader,
  replaceSearchWithPath,
  hideSecondaryNav,
  hideHeader
}) => {
  const isDesktopSizedDevice = useBreakpoint('md')

  return (
    <>
      {fixed && (
        <Helmet>
          <body className={styles.fixedBody} />
        </Helmet>
      )}
      {!hideHeader && (
        <Header
          className={headerClassName}
          collapsable={!isDesktopSizedDevice}
          stickyHeader={stickyHeader}
          replaceSearchWithPath={replaceSearchWithPath}
          hideSecondaryNav={hideSecondaryNav}
        />
      )}
      <div className={classnames(styles.content, contentClassName)} id="content">
        {children}
      </div>
    </>
  )
}

export default Chrome
